import React, { Component } from "react";
import { getAppState, withAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import { ContainerStyled } from "../../styles/shared-styles";
import { SettingsPageStyled, BlockStyled, SettingsHeading } from "./styles/Styled";
import { SecondaryMenu, Loading } from "../../services/visualLibraryService";
import { config } from "../../config/config";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getSdk } from "../../services/sdkService";
import {
  Profile,
  Devices,
  History,
  AccountStatus,
  AccountDetails,
  ContactUs,
  Help,
  Logout,
  ExitApp,
  EVoucher,
  Guid,
  ManageProfile
} from "./subsections";
import { logout } from "../../services/authenticationService";
import { checkVoucherEligiblity } from "../../services/eVoucherEligibilityService";
import {
  getProfileAvatars,
  getCurrentProfile,
  onEditProfile,
  onDeleteProfile,
  disableProfilePin,
  getUpdatedProfile
} from "../../services/multipleProfilesService";
import { getGlobalButtonFocusPath, getGlobalButtonInfo } from "../../errors/globalButtons";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { isAccessAllowedByParentalLevel } from "../../services/parentalControlService";
import { redirectTo, getNavigationReferences } from "../../services/navigationService";
import { routes } from "../../routes";
import { showDeviceLimitError, showForceLogoutError, showNotLoggedModal } from "../../services/modalsService";
import { LogoStyled, LineSeparator } from "./styles/Styled";
import getRemoteKey from "../../services/remoteService";
import FreeLogo from "../../components/FreeLogo";
import * as Sentry from "@sentry/browser";
import { getTVODAssetsStatus } from "../../services/tvodService";
import { guestProfie } from "../../utils/commonUtils";
import {
  showProfileImagesModal,
  showMultiProfileLanguageModal,
  showDeleteProfileModal,
  showProfileLockModal
} from "../../utils/multiProfileModalUtils";
import { onChangeUserLanguage, detectActiveLanguage } from "../../utils/multipleProfilesUtils";
import { historyMethods } from "../../utils/historyMethods";
import { showMultipleProfileErrorModal } from "../../services/modalsService";
import { getLast3MonthsData } from "../../utils/tvodUtils";
import { getDevices, removeDevice } from "../Player/devices";

const PAGE = "settings";
const LOGOUT = "logout";
const LOGIN = "login";
const EXIT = "exit";
const LANGUAGE = "language";
const PROFILE = "profile";
const EVOUCHER = "eVoucher";
const ACCOUNT_DETAILS = "accountDetails";
export const MANAGE_PROFILE = "manageProfile";
const DEVICES = "devices";
const HISTORY = "history";
const DISPLAY_LANGUAGE = "displayLanguage";
const PROFILE_IMAGE = "profileImage";
const PROFILE_NAME = "profileName";
const PROFILE_LOCK = "profileLock";
const VIEWING_RESTRICTIONS = "viewingRestrictions";
const DELETE_PROFILE = "deleteProfile";
const MP = "MP";

let menuItems = null;
let eVoucherData;
let isModalOpen = false;
let previousFocus = null;

export function getLanguagesList(locales) {
  const currentLanguage = i18n.getLocale();
  const languages = [];
  for (let key in locales) {
    if (locales.hasOwnProperty(key)) {
      const lang = {
        title: i18n.getWithLocale(`global.languages.${key}`, key),
        languageCode: key,
        active: key === currentLanguage
      };
      languages.push(lang);
    }
  }
  return languages;
}

function getExitConfirmationOptions() {
  return [
    {
      title: i18n.get("global.no"),
      callback: function() {
        this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
      }
    },
    {
      title: i18n.get("global.yes"),
      callback: function() {
        trackEvent(PAGE, "confirm exit app", "confirm exit app");
        resetUserSettingsData();
        getSdk().systemManager.application.exit();
      }
    }
  ];
}

function resetUserSettingsData() {
  eVoucherData = null;
}

function getDefaultSectionContentFocus() {
  return getAppState().userLogged
    ? this.isComingFromManageProfile() && isAccessAllowedByParentalLevel()
      ? MANAGE_PROFILE
      : isAccessAllowedByParentalLevel()
      ? PROFILE
      : PROFILE
    : this.isComingFromManageProfile() && isAccessAllowedByParentalLevel()
    ? MANAGE_PROFILE
    : ACCOUNT_DETAILS;
}

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      sectionLoaded: false,
      activeSubsection: getDefaultSectionContentFocus.call(this),
      languageList: getLanguagesList(config.get().locales),
      selectedLanguage: getLanguagesList(config.get().locales)[0],
      parentalControlList: config.get().parentalControlList,
      userAccount: null,
      userDevices: null,
      userHistory: [],
      profileImage: {
        avatars: "",
        currentAvatar: "",
        selectedAvatar: ""
      },
      profileName: "",
      profileId: "",
      isMasterProfile: false,
      items: [
        { key: PROFILE_IMAGE, title: i18n.get("global.editProfile.profileImageCta"), description: "" },
        { key: PROFILE_NAME, title: i18n.get("global.editProfile.profileNameCta"), description: "" },
        { key: DISPLAY_LANGUAGE, title: i18n.get("global.editProfile.displayLangCta"), description: "English" },
        { key: PROFILE_LOCK, title: i18n.get("global.editProfile.profileLockCta"), description: "Off" },
        {
          key: VIEWING_RESTRICTIONS,
          title: i18n.get("global.editProfile.ViewingRestrictionsCta"),
          description: "R (18+)"
        }
      ],
      profileData: null // profile data from previous page - Use for back navigation - don't delete that
    };
    this.changeLanguage = this.changeLanguage.bind(this);
    this.onClickDevice = this.onClickDevice.bind(this);
    this.hideSettingsModal = this.hideSettingsModal.bind(this);
    this.getMenuItems = this.getMenuItems.bind(this);
    this.changeSubsection = this.changeSubsection.bind(this);
    this.applyConfirmation = this.applyConfirmation.bind(this);
    this.showGlobalModal = this.showGlobalModal.bind(this);
    this.showLogoutModal = this.showLogoutModal.bind(this);
    this.getLogoutConfirmationOptions = this.getLogoutConfirmationOptions.bind(this);
    this.getSectionIndex = this.getSectionIndex.bind(this);
    this.getVoucherSectionIndex = this.getVoucherSectionIndex.bind(this);
    this.voucherHandleEnter = this.voucherHandleEnter.bind(this);
    this.updateHistory = this.updateHistory.bind(this);
    this.getProfileAvatars = this.getProfileAvatars.bind(this);
    this.getSelectedAvatar = this.getSelectedAvatar.bind(this);
    this.setProfileName = this.setProfileName.bind(this);
    this.onClickProfileName = this.onClickProfileName.bind(this);
    this.onClickViewingRestrictions = this.onClickViewingRestrictions.bind(this);
    this.onClickManageProfileItem = this.onClickManageProfileItem.bind(this);
    this.onClickProfileLock = this.onClickProfileLock.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.setAllProfileAvatars = this.setAllProfileAvatars.bind(this);
    this.setProfileData = this.setProfileData.bind(this);
    this.setUserProfileLanguage = this.setUserProfileLanguage.bind(this);
    this.setManageProfileItems = this.setManageProfileItems.bind(this);
    this.setUserParentalControl = this.setUserParentalControl.bind(this);
    this.onDeleteProfile = this.onDeleteProfile.bind(this);
    this.onClickDeleteProfileBtn = this.onClickDeleteProfileBtn.bind(this);
    this.showDeleteProfilePopup = this.showDeleteProfilePopup.bind(this);
    this.onKeepProfile = this.onKeepProfile.bind(this);
    this.isComingFromManageProfile = this.isComingFromManageProfile.bind(this);
    this.setProfileLockDescription = this.setProfileLockDescription.bind(this);
    this.showProfileLockPinModal = this.showProfileLockPinModal.bind(this);
    this.onClickChangeProfileLock = this.onClickChangeProfileLock.bind(this);
    this.onClickRemoveProfileLock = this.onClickRemoveProfileLock.bind(this);
    this.onUpManageProfile = this.onUpManageProfile.bind(this);
    this.onWheelUpDownManageProfile = this.onWheelUpDownManageProfile.bind(this);
    this.getPinIfNotHave = this.getPinIfNotHave.bind(this);
    this.onBack = this.onBack.bind(this);
    this.page = 1;
    this.pageSize = 3;
    this.isBottonShowing = true;
    this.isPurchaseHistoryLoadedFirstTime = true;
  }

  getSectionIndex(sectionName) {
    return this.getMenuItems().findIndex(item => item.name === sectionName);
  }

  isComingFromManageProfile() {
    const { location } = this.props;
    let referrer = location.referrer;
    let isFromManageProfilePage =
      referrer === routes.accountPassword ||
      referrer === routes.profileName ||
      referrer === routes.pinLock ||
      referrer === routes.AgeRestriction;
    return isFromManageProfilePage;
  }
  getDefaultMenuItemIndex() {
    return this.isComingFromManageProfile() && isAccessAllowedByParentalLevel()
      ? 1
      : isAccessAllowedByParentalLevel()
      ? 0
      : this.getSectionIndex(PROFILE);
  }

  getDefaultMenuItemFocused() {
    const {
      applicationState: { globalModal },
      setFocus
    } = this.props;
    const index = this.getDefaultMenuItemIndex();

    if (!globalModal) {
      setFocus(`secondaryItem_${index}`);
    }
  }

  getDefaultMenuItemSelected() {
    const { history, location } = this.props;
    const index = this.getDefaultMenuItemIndex();
    this.secondaryMenuSelectedIndex = index;
    if (this.isComingFromManageProfile()) return;
    history.replace({
      state: {
        secondaryMenuSelectedIndex: index
      },
      location: {
        referrer: location.referrer
      }
    });
  }

  keydownHandler = e => {
    const { applicationState, setFocus, pauseNavigation, resumeNavigation } = this.props;
    if (applicationState.globalModal) {
      isModalOpen = true;
    }
    if (!applicationState.globalModal) {
      isModalOpen = false;
    }
    const pressedKey = getRemoteKey(e.keyCode);
    if (pressedKey === "ARROW_UP") {
      if (applicationState.currentFocus === "selectorItem_0") {
        //setFocus(`selectorItem_0`);
        pauseNavigation();
      } else {
        resumeNavigation();
      }
    } else if (pressedKey === "ARROW_DOWN") {
      const activeSubsectionLength = this.getSubsectionListLength(this.state.activeSubsection);
      if (applicationState.currentFocus === `selectorItem_${activeSubsectionLength}`) {
        setFocus(`selectorItem_${activeSubsectionLength}`);
        pauseNavigation();
      } else {
        resumeNavigation();
      }
    } else if (pressedKey === "ARROW_LEFT") {
      if (applicationState.currentFocus === "btn_selector_1") {
        setFocus("btn_selector_0");
        return;
      }
      if (isModalOpen) {
        pauseNavigation();
      } else {
        i18n.getDirection() === i18n.directions.RIGHT_TO_LEFT
          ? resumeNavigation()
          : setFocus(`secondaryItem_${this.secondaryMenuSelectedIndex}`);
      }
    } else if (pressedKey === "ARROW_RIGHT") {
      if (isModalOpen) {
        pauseNavigation();
      } else {
        i18n.getDirection() === i18n.directions.RIGHT_TO_LEFT && this.state.activeSubsection !== ACCOUNT_DETAILS
          ? setFocus(`secondaryItem_${this.secondaryMenuSelectedIndex}`)
          : resumeNavigation();
      }
    }
    // NOTE: need to resume the navigation after pause navigation for Left and Right otherwise Enter press will not work
    if (isModalOpen) {
      resumeNavigation();
    }
  };

  async componentDidMount() {
    document.addEventListener("keydown", this.keydownHandler);
    await this.setAllProfileAvatars();
    await this.setProfileData();
    const { location } = this.props;
    const popupName = location.state && location.state.popup && location.state.popup;
    if (popupName === PROFILE_LOCK) {
      await this.showProfileLockPinModal();
    } else if (popupName === DELETE_PROFILE) {
      await this.showDeleteProfilePopup();
    }
    trackPage.call(this, PAGE);
    if (!eVoucherData && isAccessAllowedByParentalLevel()) {
      eVoucherData = await checkVoucherEligiblity(false);
    }

    menuItems = await this.generateMenuItems();
    this.isComingFromManageProfile();
    this.getDefaultMenuItemSelected();
    getAppState().userLogged && (await this.getProfile());
    await this.setState({ isLoaded: true, sectionLoaded: true });
    this.getDefaultMenuItemFocused();
    const { onRef } = this.props;
    onRef && onRef(this);
    // Force logout listening
    // showForceLogoutError.call(this);
  }

  async setAllProfileAvatars() {
    const avatars = await getProfileAvatars();
    const avatarsWithFocusPath = avatars.map((item, index) => ({ src: item, focusPath: `selectedImage_${index}` }));
    this.setState({
      profileImage: {
        ...this.state.profileImage,
        avatars: avatarsWithFocusPath
      }
    });
  }

  async setProfileData() {
    const { location } = this.props;
    const profileData = (location.state && location.state.profileData) || (await getCurrentProfile());
    if (profileData) {
      this.setState({
        profileImage: {
          ...this.state.profileImage,
          currentAvatar: profileData.avatar,
          selectedAvatar: profileData.avatar
        },
        profileName: profileData.profileName,
        language: profileData.language,
        profileId: profileData.profileId,
        isMasterProfile: profileData.isMasterProfile,
        profileData: profileData
      });
      this.setUserProfileLanguage(profileData.language);
      this.setManageProfileItems(profileData);
      this.setUserParentalControl(profileData.parentalControl);
      this.setProfileLockDescription(profileData?.isProfileLocked, profileData?.isKidLockEnabled);
    }
  }
  setUserParentalControl(parentalControl) {
    const { items } = this.state;
    items.forEach(item => {
      if (item.key === VIEWING_RESTRICTIONS) {
        item.description = `${i18n.get(`pages.settings.parentalControl.level.${parentalControl}`)} (${i18n.get(
          `pages.settings.parentalControl.description.${parentalControl}`
        )})`;
      }
    });
    this.setState({
      items: items
    });
  }
  setProfileLockDescription(isProfileLocked, isKidLockEnabled) {
    const { items } = this.state;
    items.forEach(item => {
      if (item.key === PROFILE_LOCK) {
        let profileLockStatus = isProfileLocked || isKidLockEnabled ? "On" : "Off";
        item.description = i18n.get(`pages.editProfile.${profileLockStatus.toLowerCase()}`);
      }
    });
    this.setState({
      items: items
    });
  }

  async setManageProfileItems(profileData) {
    const isUserLoggedIn = getAppState().userLogged;
    const updatedItems = [...this.state.items];
    if (isUserLoggedIn && !profileData.isMasterProfile) {
      updatedItems.push({
        key: DELETE_PROFILE,
        title: i18n.get("global.editProfile.deleteProfileCta"),
        description: ""
      });
      this.setState({ items: updatedItems });
    }
  }

  setUserProfileLanguage(key) {
    const langs = getLanguagesList(config.get().locales);
    const selectedLangDetail = langs.find(lang => lang.languageCode === key);
    this.onChangeProfileLanguage(selectedLangDetail);
  }

  onChangeProfileLanguage(selectedLangDetail) {
    const langs = getLanguagesList(config.get().locales);
    let languageList = [...langs];
    const languageListWithActiveLang = detectActiveLanguage(languageList, selectedLangDetail);

    const { items } = this.state;
    items.forEach(item => {
      if (item.key === DISPLAY_LANGUAGE) {
        item.title = i18n.get("global.editProfile.displayLangCta");
        item.description = selectedLangDetail.title;
      } else if (item.key === PROFILE_IMAGE) {
        item.title = i18n.get("global.editProfile.profileImageCta");
      } else if (item.key === PROFILE_NAME) {
        item.title = i18n.get("global.editProfile.profileNameCta");
      } else if (item.key === PROFILE_LOCK) {
        item.title = i18n.get("global.editProfile.profileLockCta");
      } else if (item.key === VIEWING_RESTRICTIONS) {
        item.title = i18n.get("global.editProfile.ViewingRestrictionsCta");
      } else if (item.key === DELETE_PROFILE) {
        item.title = i18n.get("global.editProfile.deleteProfileCta");
      }
    });
    this.setState({
      items: items,
      selectedLanguage: selectedLangDetail,
      languageList: languageListWithActiveLang
    });
    const { profileData } = this.state;
    const parentalControl = profileData && profileData.parentalControl;
    this.setUserParentalControl(parentalControl);
    this.setProfileLockDescription(profileData?.isProfileLocked, profileData?.isKidLockEnabled);
    this.isFromLanguageModal = true;
    previousFocus = null;
    this.props.setFocus("secondaryItem_0");
  }
  onKeepProfile() {
    trackEvent("profile_delete_keep_clicked", null, MP, this.state.profileData);
    this.props.stateActions.hideGlobalModal();
    this.props.setFocus("secondaryItem_1");
  }
  async showDeleteProfilePopup() {
    const { location } = this.props;
    const hasHistoryState = !!(location && location.state);
    const isPasswordVerified = hasHistoryState && location.state.isPasswordVerified;
    if (hasHistoryState && isPasswordVerified) {
      await showDeleteProfileModal.call(this, this.onKeepProfile, this.onDeleteProfile);
    }
  }
  setProfileName() {
    const { history } = this.props;
    const hasHistoryState = !!(history.location && history.location.state);
    hasHistoryState &&
      history.location.state.profileName &&
      this.setState({ profileName: history.location.state.profileName });
  }
  onUpManageProfile(index, focusName) {
    if (index === 0) {
      this.props.setFocus(`selectorItem_${index}_${focusName}`);
    } else {
      this.props.setFocus(`selectorItem_${index - 1}_${focusName}`);
    }
  }

  onWheelUpDownManageProfile(index, focusName) {
    this.props.setFocus(`selectorItem_${index}_${focusName}`);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownHandler);
    eVoucherData = null;
  }
  async changeLanguage(language) {
    const sdk = await getSdk();
    localStorage.setItem("locale", language.languageCode);
    await sdk.userManager.setLanguage(language.languageCode);
    this.props.stateActions.setLocale(language.languageCode);
    await sdk.mediaManager.clearLayoutCache();
    menuItems = await this.generateMenuItems();
    this.setUserProfileLanguage(language.languageCode);
  }

  async onClickDevice(device) {
    isModalOpen = true;
    this.props.stateActions.showSettingsModal({
      modalTitle: i18n.get("pages.settings.devices.removeDevice"),
      modalText: device && device.title,
      buttons: [
        {
          ...getGlobalButtonInfo("delete"),
          buttonHandler: async () => {
            this.setState({ sectionLoaded: false }, async () => {
              this.hideSettingsModal();
              isModalOpen = false;
              const status = await removeDevice.call(this, device.id);
              if (status === "34004" || status === "34005" || status === "100010") {
                showDeviceLimitError.call(this, this.hideSettingsModal);
                this.setState({ sectionLoaded: true });
              } else {
                const userDevices = await getDevices();
                userDevices &&
                  this.setState({ userDevices }, () => {
                    this.setState({ sectionLoaded: true });
                  });
              }
            });
          }
        },
        {
          ...getGlobalButtonInfo("cancel"),
          buttonHandler: () => {
            this.hideSettingsModal();
            isModalOpen = false;
          }
        }
      ],
      descriptionFontWeight: "bold"
    });
    this.props.setFocus(getGlobalButtonFocusPath("delete"));
  }

  onChange({ focusedItem }) {
    this.props.setFocus(focusedItem);
  }

  hideSettingsModal() {
    this.props.stateActions.hideSettingsModal();
    this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);

    // Force logout checks-  if yes , show the popup.
  }

  applyConfirmation(selectedOption) {
    if (selectedOption.callback) {
      selectedOption.callback.call(this);
    }
  }

  getMenuItems() {
    if (menuItems) {
      return menuItems;
    }
    const items = this.generateMenuItems();
    return items;
  }

  getLogoutConfirmationOptions() {
    return [
      {
        title: i18n.get("pages.settings.logout.title").toUpperCase(),
        callback: function() {
          this.showLogoutModal();
        }
      }
    ];
  }

  redirectToStore() {
    return [
      {
        title: i18n.get("pages.settings.history.store").toUpperCase(),
        callback: function() {
          this.redirection();
        }
      }
    ];
  }

  redirection() {
    const { history } = this.props;
    history.push(routes.store);
  }
  async updateHistory() {
    let selectedIndex = this.state.userHistory && this.state.userHistory.length;
    this.setState({ sectionLoaded: false });
    this.page += 1;
    this.isPurchaseHistoryLoadedFirstTime = false;
    const history = await this.getHistory(this.pageSize, this.page);
    history && (history.length === 0 || history.length === 1 || history.length === 2)
      ? (this.isBottonShowing = false)
      : (this.isBottonShowing = true);
    if (history) {
      let userHistory = [...this.state.userHistory, ...history];
      userHistory && this.setState({ userHistory });
    }
    this.setState({ sectionLoaded: true });

    if (history.length < 3) {
      selectedIndex = selectedIndex - 1;
    }
    this.props.setFocus(`selectorItem_${selectedIndex}`);
  }

  showLogoutModal() {
    isModalOpen = true;
    this.props.stateActions.showSettingsModal({
      modalText: i18n.get("pages.settings.logout.areYouSure"),
      modalTitle: i18n.get("pages.settings.logout.title"),
      buttons: [
        {
          ...getGlobalButtonInfo("yes"),
          buttonHandler: async () => {
            const { history, stateActions } = this.props;
            trackEvent(PAGE, "confirm logout", "confirm logout");
            const isResetXToken = true;
            await logout(isResetXToken, "logout_click");
            isModalOpen = false;
            stateActions.userLoggedOut();
            resetUserSettingsData();
            menuItems = await this.generateMenuItems();
            history.push(routes.splash);
            this.props.stateActions.hideSettingsModal();
          }
        },
        {
          ...getGlobalButtonInfo("no"),
          buttonHandler: () => {
            isModalOpen = false;
            this.props.stateActions.hideSettingsModal();
            this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
          }
        }
      ]
    });
    this.props.setFocus(getGlobalButtonFocusPath("no"));
  }

  showGlobalModal(retryCallback) {
    isModalOpen = true;
    const online = !!getAppState().isOnline;
    const errorText = online
      ? i18n.get("global.errors.genericError")
      : i18n.get("global.errors.internetConnectivity.text");
    this.props.stateActions.showGlobalModal({
      modalText: errorText,
      modalTitle: !online && i18n.get("global.errors.internetConnectivity.title"),
      buttons: [
        {
          ...getGlobalButtonInfo("retry"),
          buttonHandler: async () => {
            this.props.stateActions.hideGlobalModal();
            isModalOpen = false;
            if (typeof retryCallback === "function") {
              try {
                await retryCallback.call(this);
                this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
              } catch (e) {
                this.showGlobalModal(retryCallback);
              }
            } else {
              this.componentDidMount.bind(this);
            }
          }
        },
        {
          ...getGlobalButtonInfo("close"),
          buttonHandler: () => {
            isModalOpen = false;
            this.props.stateActions.hideGlobalModal();
            this.props.history.goBack();
          }
        }
      ]
    });
    this.props.setFocus(getGlobalButtonFocusPath("retry"));
  }

  async getProfile() {
    const userAccount = this.state.userAccount || (await getSdk().userManager.get());
    userAccount && this.setState({ userAccount });
  }

  async getAccountStatus() {
    const userAccount = this.state.userAccount || (await getSdk().userManager.get({ avoidCache: true }));
    // userAccount && (userAccount.billing = userBilling || (await getSdk().userManager.getBilling({ avoidCache: true })));
    userAccount && (userAccount.billing = await getSdk().userManager.getBilling({ avoidCache: true }));
    userAccount && this.setState({ userAccount });
  }

  async getDevices() {
    const userDevices = this.state.userDevices || (await getDevices());
    userDevices && this.setState({ userDevices });
  }

  async getHistory(pageSize, pageNo) {
    const historyData = await getTVODAssetsStatus(null, pageSize, pageNo);
    const filteredData = getLast3MonthsData(historyData);
    return filteredData;
  }

  async generateMenuItems() {
    const currentProfile = await getCurrentProfile();
    this.props.stateActions.setCurrentProfileId(currentProfile?.profileId);
    const subsectionCallbacks = {
      profile: async () => {
        try {
          await this.getProfile();
        } catch (e) {
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          this.showGlobalModal(this.getProfile);
        }
      },
      accountStatus: async () => {
        try {
          await this.getAccountStatus();
        } catch (e) {
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          this.showGlobalModal(this.getAccountStatus);
        }
      },
      devices: async () => {
        try {
          await this.getDevices();
        } catch (e) {
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          this.showGlobalModal(this.getDevices);
        }
      },
      history: async () => {
        try {
          const userHistory = await this.getHistory(this.pageSize, this.page);

          let updatedUserHistory = [];
          if (this.isPurchaseHistoryLoadedFirstTime) {
            updatedUserHistory = [...userHistory];
          } else if (this.page === 1 && !this.isPurchaseHistoryLoadedFirstTime) {
            updatedUserHistory = [...this.state.userHistory, ...userHistory];
          } else {
            updatedUserHistory = [...this.state.userHistory];
          }
          userHistory && this.setState({ userHistory: updatedUserHistory });
        } catch (e) {
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          this.showGlobalModal(this.getHistory);
        }
      }
    };
    const userLogged = getAppState().userLogged;

    menuItems = config.get().settingsSubsections.filter(item => (!eVoucherData ? item.name !== EVOUCHER : item));

    menuItems.forEach(item => {
      const languageKey = `pages.settings.menu.${item.name}`;
      const languageValue = i18n.get(`pages.settings.menu.${item.name}`);
      item.tagTitle = languageKey !== languageValue ? languageValue : i18n.get(`global.${item.name}`);
      item.beforeSubsectionEnter = subsectionCallbacks[item.name];
      if (item.showInLoggedInState && item.showInLoggedOutState) {
        item.show = true;
      } else if (userLogged && item.showInLoggedInState) {
        item.show = true;
      } else if (!userLogged && item.showInLoggedOutState) {
        item.show = true;
      } else {
        item.show = false;
      }
      if ((currentProfile && currentProfile?.profileCategory) === "KIDS" && !item.isForKids) {
        item.show = false;
      }
    });
    return menuItems.filter(item => (item.show !== undefined ? item.show : true));
  }

  async getProfileAvatars() {
    try {
      const avatars = await getProfileAvatars();
      this.setState({
        ...this.state,
        profileImage: {
          avatars: avatars,
          currentAvatar: avatars[0]
        }
      });
    } catch (error) {
      console.log("==> ~ EditProfile ~ getProfileAvatars ~ error:", error);
    }
  }
  async getSelectedAvatar(selectedAvatar) {
    try {
      await onEditProfile.call(this, { avatar: selectedAvatar, profileId: this.state.profileId });
      const currentProfile = await getCurrentProfile();
      const updatedProfile = {
        location: "manage profile screen",
        isAvatarChange: !!(this.state.profileImage.currentAvatar !== selectedAvatar)
      };
      trackEvent("profile_settings_updated", null, "MP", {
        profileData: { updatedProfileId: currentProfile?.profileId, ...currentProfile },
        updatedProfile
      });
      this.props.stateActions.hideGlobalModal();
      this.props.setFocus(previousFocus);
      this.setState({
        isLoaded: true,
        profileData: currentProfile,
        profileImage: {
          ...this.state.profileImage,
          currentAvatar: selectedAvatar
        }
      });
      previousFocus = null;
    } catch (e) {
      console.log("==> ~ EditProfile ~ onSaveChanges ~ e:", e);
      showMultipleProfileErrorModal.call(this, previousFocus);
    }
  }
  async changeSubsection(index) {
    const { profileData } = this.state;
    const currentMenuItems = this.getMenuItems();
    const currentSelectedMenuOption = currentMenuItems[index];
    if (currentSelectedMenuOption.name === LOGIN) {
      redirectTo.call(this, routes.pin, { backDestination: routes.settings });
      return;
    }
    this.secondaryMenuSelectedIndex = index;
    this.setState({ sectionLoaded: false });
    const selectedSection = Object.values(currentMenuItems)[index];
    this.lastSelectedSectionIndex = index;
    selectedSection.beforeSubsectionEnter && (await selectedSection.beforeSubsectionEnter());
    this.setState({ activeSubsection: selectedSection.name, sectionLoaded: true });
    // this.page = 1;
    // this.isBottonShowing = true;
    trackPage.call(this, PAGE);
    const subSectionName = selectedSection?.name;
    const eventAction =
      subSectionName === ACCOUNT_DETAILS
        ? "account_details_clicked"
        : subSectionName === DEVICES
        ? "devices_and_access_clicked"
        : subSectionName === HISTORY
        ? "payment_history_clicked"
        : "";
    eventAction && trackEvent(eventAction, null, MP, profileData);
    if (
      selectedSection.name === LOGOUT ||
      selectedSection.name === EXIT ||
      selectedSection.name === HISTORY ||
      (selectedSection.name === DEVICES && this.state.userDevices.length > 0)
    ) {
      this.props.setFocus("selectorItem_0");
    } else if (selectedSection.name === LANGUAGE) {
      const selectedLanguageIndex = this.state.languageList.findIndex(item => item.active);
      this.props.setFocus(`selectorItem_${selectedLanguageIndex}`);
    } else if (selectedSection.name === MANAGE_PROFILE) {
      trackEvent("manage_profiles_clicked", null, MP, profileData);
      this.props.setFocus(`selectorItem_0_${MANAGE_PROFILE}`);
    }
  }
  async showMultiProfileLanguageModal() {
    const { languageList, selectedLanguage } = this.state;
    await showMultiProfileLanguageModal.call(this, languageList, selectedLanguage);
  }
  async onChangeLanguage(selectedLanguage, availableLanguages) {
    try {
      await this.setState({ isLoaded: false });
      await onEditProfile.call(this, { language: selectedLanguage.languageCode, profileId: this.state.profileId });
      onChangeUserLanguage.call(this, selectedLanguage, availableLanguages, previousFocus);
      await this.changeLanguage(selectedLanguage);
      const currentProfile = await getCurrentProfile();
      this.setState({ isLoaded: true, profileData: currentProfile });
      this.props.history.push("/settings");
    } catch (e) {
      console.log("==> ~ EditProfile ~ onSaveChanges ~ e:", e);
      showMultipleProfileErrorModal.call(this, previousFocus);
      await this.setState({ isLoaded: true });
    }
  }
  onClickProfileName() {
    const profileData = {
      ...this.state.profileData,
      profileName: this.state.profileName,
      avatar: this.state.profileImage.currentAvatar,
      language: this.state.selectedLanguage.languageCode
    };
    this.props.history.push({
      pathname: routes.profileName,
      state: {
        backDestination: routes.settings,
        profileName: this.state.profileName,
        avatar: this.state.profileImage.currentAvatar,
        profileData: profileData,
        isCallEditAPI: true,
        isToShowPopup: true
      }
    });
  }
  onClickManageProfileItem(item) {
    const { profileData } = this.state;
    previousFocus = this.props.applicationState.currentFocus;
    if (item.key === VIEWING_RESTRICTIONS) {
      trackEvent("viewing_restrictions_setting_clicked", null, MP, profileData);
      this.onClickViewingRestrictions();
    } else if (item.key === PROFILE_LOCK) {
      trackEvent("profile_lock_setting_clicked", null, MP, profileData);
      this.onClickProfileLock();
    } else if (item.key === DISPLAY_LANGUAGE) {
      trackEvent("language_setting_clicked", null, MP, profileData);
      this.showMultiProfileLanguageModal();
    } else if (item.key === PROFILE_NAME) {
      trackEvent("profile_name_setting_clicked", null, MP, profileData);
      this.onClickProfileName(item);
    } else if (item.key === PROFILE_IMAGE) {
      trackEvent("avatar_setting_clicked", null, MP, profileData);
      showProfileImagesModal.call(this);
    } else if (item.key === DELETE_PROFILE) {
      this.onClickDeleteProfileBtn();
    }
  }
  async onClickDeleteProfileBtn() {
    redirectTo.call(
      this,
      routes.accountPassword,
      {
        backDestination: routes.settings,
        profileId: this.state.profileId,
        profileName: this.state.profileName,
        avatar: this.state.profileImage.currentAvatar,
        profileData: this.state.profileData,
        popup: DELETE_PROFILE
      },
      historyMethods.PUSH
    );
  }
  async onDeleteProfile() {
    const { location } = this.props;
    const hasHistoryState = !!(location && location.state);
    const accountPassword = location.state.accountPassword;
    if (hasHistoryState && accountPassword) {
      const data = {
        profileId: this.state.profileId,
        password: accountPassword
      };
      try {
        const response = await onDeleteProfile(data);
        if (response === 200) {
          trackEvent("profile_deleted", null, MP, {
            updatedProfileId: this.state.profileId,
            ...this.state.profileData
          });
          this.props.stateActions.hideGlobalModal();
          this.props.history.replace({
            pathname: routes.profileSelector
          });
        }
      } catch (e) {
        console.log("==> ~ EditProfile ~ onSaveChanges ~ e:", e);
        showMultipleProfileErrorModal.call(this, previousFocus);
      }
    }
  }

  getSubsectionLayout(subsection) {
    const subsections = {
      profile: this.state.userAccount && <Profile userAccount={this.state.userAccount} />,
      manageProfile: (
        <ManageProfile
          parentProps={this.props}
          profileImage={this.state.profileImage}
          profileName={this.state.profileName}
          getSelectedAvatar={this.getSelectedAvatar}
          onClickProfileName={this.onClickProfileName}
          onClickViewingRestrictions={this.onClickViewingRestrictions}
          onClickProfileLock={this.onClickProfileLock}
          editProfileItemsList={this.state.items}
          onClick={this.onClickManageProfileItem}
          onUpManageProfile={this.onUpManageProfile}
          onWheelUpDownManageProfile={this.onWheelUpDownManageProfile}
          isLocked={this.state.profileData?.isProfileLocked}
          isKidLockEnabled={this.state.profileData?.isKidLockEnabled || ""}
          isKidsProfile={this.state.profileData?.profileCategory}
        />
      ),
      accountDetails: <AccountDetails parentProps={this.props} userAccount={this.state.userAccount} />,
      accountStatus: this.state.userAccount && <AccountStatus userAccount={this.state.userAccount} />,
      devices: this.state.userDevices && (
        <Devices devices={this.state.userDevices} onItemSelected={this.onClickDevice} />
      ),
      history: (
        <History
          historylist={this.state.userHistory}
          onItemSelected={
            this.state.userHistory && this.state.userHistory.length > 0 ? this.updateHistory : () => this.redirection()
          }
          isBottonShowing={this.isBottonShowing}
          confirmationOptions={this.redirectToStore()}
          onChange={this.onChange}
          isFromSettingsPage={true}
        />
      ),
      contactUs: <ContactUs />,
      help: <Help />,
      logout: (
        <Logout
          confirmationOptions={this.getLogoutConfirmationOptions()}
          onItemSelected={this.applyConfirmation}
          isFromSettingsPage={true}
        />
      ),
      exit: <ExitApp confirmationOptions={getExitConfirmationOptions()} onItemSelected={this.applyConfirmation} />,
      ...(!!eVoucherData && {
        eVoucher: (
          <EVoucher
            enterHandler={this.voucherHandleEnter}
            sectionItemFocused={this.lastSelectedSectionIndex || this.getVoucherSectionIndex()}
          />
        )
      })
    };
    return subsections[subsection];
  }

  getSubsectionListLength(subsection) {
    switch (subsection) {
      case "language":
        return this.state.languageList.length;
      case "parentalControl":
        return this.state.parentalControlList.length;
      case "devices":
        return this.state.userDevices.length;
      case "history":
        return this.state.userHistory.length;
      case "logout":
        return 1; // as we have only one button
      default:
        return 1;
    }
  }

  getVoucherSectionIndex() {
    return this.getSectionIndex(EVOUCHER);
  }

  voucherHandleEnter() {
    const userLogged = getAppState().userLogged;
    const eventAction = userLogged ? "settings_user_selects_startnow" : "settings_user_selects_joinnow";
    const path = userLogged ? routes.redeem : routes.signup;
    trackEvent("signup", eventAction);
    redirectTo.call(this, path);
  }

  getGuestID() {
    const gProfie = guestProfie();
    return gProfie?.uniqueReference;
  }
  isShowGuid() {
    if (!getAppState().userLogged && getAppState().isGuestProfile) return true;
    return false;
  }

  onClickViewingRestrictions() {
    const userLogged = getAppState().userLogged;
    if (!userLogged) {
      showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeModal);
      return;
    }
    this.props.history.push({
      pathname: routes.accountPassword,
      state: {
        profileId: this.state.profileId,
        profileData: this.state.profileData,
        backDestination: routes.settings,
        nextPage: routes.AgeRestriction,
        avatar: this.state.profileImage.currentAvatar
      }
    });
  }
  onClickProfileLock() {
    const userLogged = getAppState().userLogged;
    if (!userLogged) {
      showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeModal);
      return;
    }
    const isLocked = this.state.profileData?.isProfileLocked || this.state.profileData?.isKidLockEnabled;
    this.props.history.push({
      pathname: routes.accountPassword,
      state: {
        profileName: this.state.profileName,
        profileId: this.state.profileId,
        profileData: this.state.profileData,
        avatar: this.state.profileImage.currentAvatar,
        createPin: true,
        backDestination: routes.settings,
        nextPage: !isLocked ? routes.pinLock : routes.settings,
        popup: PROFILE_LOCK
      }
    });
  }
  async getPinIfNotHave() {
    let updatedProfileData = null;
    if (!this.state.profileData?.pin) {
      updatedProfileData = await getUpdatedProfile(this.state.profileData?.profileId, getAppState().country);
      this.setState({
        profileData: updatedProfileData
      });
    }
  }
  async showProfileLockPinModal() {
    await this.getPinIfNotHave();
    const isLocked = this.state.profileData?.isProfileLocked || this.state.profileData?.isKidLockEnabled;
    if (isLocked) {
      const { profileData } = this.state;
      await showProfileLockModal.call(
        this,
        profileData?.pin,
        profileData?.profileName,
        this.onClickChangeProfileLock,
        this.onClickRemoveProfileLock,
        this.closeModal
      );
    }
  }
  closeModal() {
    this.props.stateActions.hideGlobalModal();
    this.props.setFocus(previousFocus);
    previousFocus = null;
  }
  onClickChangeProfileLock() {
    this.closeModal();
    this.props.history.push({
      pathname: routes.pinLock,
      state: {
        profileName: this.state.profileName,
        profileId: this.state.profileId,
        profileData: this.state.profileData,
        createPin: true,
        backDestination: routes.settings,
        popup: null
      }
    });
  }
  async onClickRemoveProfileLock() {
    const { profileData } = this.state;
    const response = await disableProfilePin({ profileId: profileData?.profileId });
    if (response?.status === 200) {
      const updatedProfileData = await getUpdatedProfile(profileData?.profileId, getAppState().country);
      const updatedProfile = {
        location: "manage profile screen",
        isProfileLockChange: true
      };
      trackEvent("profile_settings_updated", null, "MP", {
        profileData: { updatedProfileId: updatedProfileData?.profileId, ...updatedProfileData },
        updatedProfile
      });
      trackEvent("profile_pin_removed", null, MP, updatedProfileData);
      this.setState({
        profileData: updatedProfileData
      });
      this.setProfileLockDescription(updatedProfileData?.isProfileLocked, updatedProfileData?.isKidLockEnabled);
      this.closeModal();
    }
  }
  onBack() {
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  doNothing() {}

  render() {
    return (
      <SettingsPageStyled>
        {this.state.isLoaded ? (
          <>
            <LineSeparator />
            <LogoStyled>
              <FreeLogo />
            </LogoStyled>
            <SettingsHeading rank={1} text={i18n.get("pages.settings.title")} size={"large"} fontWeight="regular" />
            <ContainerStyled>
              <BlockStyled>
                <SecondaryMenu
                  items={this.getMenuItems()}
                  onClick={this.changeSubsection}
                  currentFocus={this.props.applicationState.currentFocus}
                  secondaryMenuSelectedIndex={this.secondaryMenuSelectedIndex}
                  onUpdateWheelState={this.doNothing}
                  isFromSettingsPage={true}
                  size="medium"
                  weight="semiBold"
                />
                {this.isShowGuid() && <Guid guid={this.getGuestID()} />}
              </BlockStyled>
              <BlockStyled>
                {this.state.sectionLoaded ? (
                  this.getSubsectionLayout(this.state.activeSubsection)
                ) : (
                  <Loading overlay opacity="0" />
                )}
              </BlockStyled>
            </ContainerStyled>
          </>
        ) : (
          <Loading overlay />
        )}
      </SettingsPageStyled>
    );
  }
}

export default withAppState(withSubtheme(Settings));
